import React from 'react';
import { ENABLE_PROTESTS } from '../constants/config';

export default function HowToPlay({ onClose }) {
  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
      <div className="bg-cream border-2 border-ink p-5 sm:p-8 max-w-md w-full max-h-[85vh] overflow-y-auto relative">
        <button
          onClick={onClose}
          className="absolute top-3 right-4 text-ink-faint hover:text-ink text-xl font-body"
        >
          &times;
        </button>

        <h2 className="text-2xl font-serif font-black text-ink text-center mb-1">
          Approximate the Grid
        </h2>
        <div className="w-16 mx-auto border-t-2 border-ink mt-1 mb-5" />

        <div className="space-y-4 text-sm font-body text-ink">

          <p>
            <strong>Think of a word that is similar to both the column header and the row header. Only words that satisfy both will score high.</strong>
          </p>

          <div className="space-y-2">
            <p><strong>Rules</strong></p>
            <ul className="list-disc list-inside space-y-1 text-ink-light">
              <li>Words must be at least 4 letters</li>
              <li>You can't use the adjective itself or its root</li>
              <li>No repeating words or their roots</li>
              <li>You get <strong>2 retries</strong> for the initial 9 cells, the best score is kept</li>
              {ENABLE_PROTESTS && (
                <li>After submitting, you can <strong>protest</strong> a score. If your protest is approved, you get another one!</li>
              )}
            </ul>
          </div>

          <div className="space-y-2">
            <p><strong>Tips</strong></p>
            <ul className="list-disc list-inside space-y-1 text-ink-light">
              <li>Creativity is rewarded. Rare words beat generic ones</li>
              <li>Sometimes, it may be impossible to find a good fit. In that case, just try satisfying one of the words</li>
              <li>Tap the <span className="text-ink-faint">&#9432;</span> icon to see adjective definitions</li>
              <li>The two <span className="inline-block w-2 h-2 rounded-full bg-green-600 align-middle" /> <span className="inline-block w-2 h-2 rounded-full bg-yellow-500 align-middle" /> dots show how well your word matches each adjective (red = low, green = high)</li>
              <li>A new puzzle drops every day at midnight ET</li>
            </ul>
          </div>
        </div>

        <button
          onClick={onClose}
          className="w-full mt-6 py-3 bg-ink text-cream font-serif font-bold border-2 border-ink hover:bg-ink-light transition-colors"
        >
          Play
        </button>
      </div>
    </div>
  );
}
